import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseResponse } from "app/business/common/baseresponse";
import { tblRoleWiseUserPermission } from "app/models/config/tblrolewiseuserpermission";
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    constructor(private http: HttpClient) { }

    async getNavTree(): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/Config/GetNavTree')
            .toPromise() as BaseResponse;
    }

    async getUserPermissionWiseNavTree(userId: string, roleId: number): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/Config/GetUserPermissionWiseNavTree/' + userId + "/" + roleId)
            .toPromise() as BaseResponse;
    }

    async getRoleWiseUserPermissionByUserId(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/Config/GetRoleWiseUserPermissionByUserId/' + userId)
            .toPromise() as BaseResponse;
    }

    async saveRoleWiseUserPermission(tblUserPermissions: tblRoleWiseUserPermission[]): Promise<BaseResponse> {
        const permissions = tblUserPermissions.map(permission => ({
            ...permission,
            navTreeId: String(permission.navTreeId)
        }));

        return await this.http.post(environment.apiUrl + '/Config/SaveRoleWiseUserPermission', permissions)
            .toPromise() as BaseResponse;
    }

    async getSettingByKey(key: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/Config/SaveUserPermission/' + key)
            .toPromise() as BaseResponse;
    }

    async getAllSettings(): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/Config/GetAllSettings')
            .toPromise() as BaseResponse;
    }

    // Enhanced NavTree methods
    async getUsers(): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/GetUsers')
            .toPromise() as BaseResponse;
    }

    async getRoleWiseUserPermission(): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/Config/GetRoleWiseUserPermission')
            .toPromise() as BaseResponse;
    }

    async updateRoleWiseUserPermission(permissionData: any): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + '/Config/UpdateRoleWiseUserPermission', permissionData)
            .toPromise() as BaseResponse;
    }

    // SuperAdmin permission fix methods
    async fixSuperAdminPermissions(): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + '/Config/FixSuperAdminPermissions', {})
            .toPromise() as BaseResponse;
    }

        async verifySuperAdminAccess(): Promise<BaseResponse> {
            return await this.http.get(environment.apiUrl + '/Config/VerifySuperAdminAccess')
                .toPromise() as BaseResponse;
        }

        async setupSuperAdminFullPermissions(): Promise<BaseResponse> {
            return await this.http.post(environment.apiUrl + '/Config/SetupSuperAdminFullPermissions', {})
                .toPromise() as BaseResponse;
        }

        async getSuperAdminPermissionCount(): Promise<BaseResponse> {
            return await this.http.get(environment.apiUrl + '/Config/GetSuperAdminPermissionCount')
                .toPromise() as BaseResponse;
        }
} 